import ProjectSetUpPageStore, {
  ProjectDetailsTabs,
} from '~/client/src/desktop/views/ProjectSetUp/ProjectSetUpPage.store'
import ProjectSetUpPage from '~/client/src/desktop/views/ProjectSetUp/ProjectSetUpPages'

// Opens the project settings Time tab, where the project working hours are
// edited — the destination for the inherited-hours chip's "Project Settings" link.
export function navigateToProjectTimeSettings(
  projectSetUpPageStore: ProjectSetUpPageStore,
): void {
  projectSetUpPageStore.activeTab = ProjectDetailsTabs.Time
  projectSetUpPageStore.navigateTo(ProjectSetUpPage.PROJECT_DETAILS)
}
